import { render } from "./viewmoreLayout.vue?vue&type=template&id=2f363cb2"
import script from "./viewmoreLayout.vue?vue&type=script&lang=js"
export * from "./viewmoreLayout.vue?vue&type=script&lang=js"

import "./viewmoreLayout.vue?vue&type=style&index=0&id=2f363cb2&scocped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__